import { OptionType, Question } from 'types'

export const extractSubquestionsFromOptions = (options: OptionType[]): Question[] => {
  let _subquestions: Question[] = []
  for (let optionItem of options) {
    _subquestions.push(...optionItem.subquestions)
  }
  return _subquestions
}
